import React from "react";
import classNames from "classnames";

const NumberInput = React.forwardRef(({
  id,
  dataCy,
  value,
  onChange,
  onFocus,
  onBlur,
  placeholder = "Enter a number",
  min = 0,
  max,
  step = 1,
  isDisabled = false,
  preventChars = null,
  hasError = false,
  showErrorMessage = false,
  errorMessage = "Invalid number",
}, ref) => {
  const hasValue = value !== "" && value !== null && value !== undefined;

  const handleChange = (e) => {
    const newValue = e.target.value;
    if (/^\d*$/.test(newValue)) { // Allow only digits
      onChange(e);
    }
  };

  return (
    <div className="relative flex flex-col w-full">
      {/* Container */}
      <div
        className={classNames(
          "relative flex items-center w-full rounded-lg px-4 py-[14px] tw-paragraph-lg transition-all bg-white",
          hasError && "border border-[var(--color-alert)] hover-border-thicker-input-red",
          !hasError && !isDisabled && "border border-gray-100 hover-border-thicker-input",
          isDisabled && "border border-gray-100 text-gray-400"
        )}
      >
        <input
          ref={ref}
          id={id}
          data-cy={dataCy}
          type="number"
          value={value}
          onChange={handleChange}
          min={min}
          max={max}
          step={step}
          disabled={isDisabled}
          onFocus={onFocus}
          onBlur={onBlur}
          onKeyDown={preventChars ? (e) => {
            if (preventChars.includes(e.key)) {
              e.preventDefault();
            }
          } : undefined}
          placeholder=" "
          className={classNames(
            "peer w-full outline-none bg-transparent font-semibold appearance-none",
            isDisabled ? "text-gray-400" : "text-gray-900"
          )}
        />

        {/* Floating Label */}
        <label
          htmlFor={id}
          className={classNames(
            "tw-paragraph-lg",
            "bg-transparent absolute px-1 left-4 text-gray-400 transition-all pointer-events-none transform",
            (hasValue
              ? "top-[-12px] text-sm -translate-y-0"
              : "top-1/2 -translate-y-1/2"),
            "peer-focus:top-[-12px] peer-focus:left-[16px] peer-focus:-translate-y-0 peer-focus:text-sm",
            "peer-focus:bg-transparent peer-focus:z-10 label-background",
            "before:content-[''] before:absolute before:bottom-0 before:left-0 before:right-0",
            "before:h-[13px] before:bg-white before:z-[-1] before:transform before:-translate-y-1/2"
          )}
        >
          {placeholder}
        </label>
      </div>

      {/* Error Message */}
      {hasError && showErrorMessage && !isDisabled && (
        <div className="absolute left-0 top-full flex items-center gap-2 text-gray-800 mt-1 ml-4">
          <span className="tw-paragraph-sm font-semibold">{errorMessage}</span>
        </div>
      )}
    </div>
  );
});

export default NumberInput;